var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_FILL0_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.55078 10.5188H10.4195V9.39375H4.55078V10.5188ZM4.55078 8.08125H13.5508V6.95625H4.55078V8.08125ZM4.55078 5.64375H13.5508V4.51875H4.55078V5.64375ZM1.55078 16.5V1.5H16.5508V13.5H4.55078L1.55078 16.5ZM2.67578 12.375H15.4258V2.625H2.67578V12.375Z",
    fill: "#19191D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextImg);
export default __webpack_public_path__ + "static/media/textImg.db36d4427fd0e0a552012da40f12e603.svg";
export { ForwardRef as ReactComponent };